import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {HoverStyles, Text, TextButton} from '@wix/wix-ui-tpa/cssVars'
import {useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {useCurrencyFormatter} from '../../../../../../../commons/hooks/currency'
import {useAppSelector} from '../../../../hooks/runtime'
import {isCouponInputVisible, isGiftCardInputVisible} from '../../../../selectors/checkout-options'
import {isMembershipSelectorVisible} from '../../../../selectors/paid-plans'
import {GiftCardInput} from '../../../gift-card-input'
import {CouponInput} from '../../../summary/coupon-input'
import {MembershipDropdown} from '../../../summary/membership-dropdown'
import s from './checkout-summary.scss'
import {classes} from './checkout-summary.st.css'
import {CheckoutSummaryProps} from './interfaces'

const orderOverviewLabelId = 'order-overview'
const orderOverviewButtonId = 'order-overview-button'

export const CheckoutSummary = ({onViewAllItems, currentStep, buyerTotal}: CheckoutSummaryProps) => {
  const {t} = useTranslation()
  const {getFormattedMoney} = useCurrencyFormatter()

  const couponInputVisible = useAppSelector(isCouponInputVisible)
  const membershipSelectorVisible = useAppSelector(isMembershipSelectorVisible)
  const giftCardInputVisible = useAppSelector(isGiftCardInputVisible)

  return (
    <div className={s.container}>
      {couponInputVisible && <CouponInput currentStep={currentStep} mobile />}
      {giftCardInputVisible && <GiftCardInput mobile currentStep={currentStep} />}
      {membershipSelectorVisible && <MembershipDropdown currentStep={currentStep} mobile />}
      <div className={s.summary}>
        <div className={classNames(s.row, classes.details)}>
          <Text tagName="span" id={orderOverviewLabelId}>
            {t('mobile.couponForm.title')}
          </Text>
          <TextButton
            hoverStyle={HoverStyles.underline}
            onClick={onViewAllItems}
            data-hook={DH.SHOW_SUMMARY_BUTTON}
            id={orderOverviewButtonId}
            aria-labelledby={`${orderOverviewButtonId} ${orderOverviewLabelId}`}
          >
            {t('mobile.summary.showTickets')}
          </TextButton>
        </div>
        <div className={classNames(s.row, classes.total)} data-hook={DH.CHECKOUT_SUMMARY_TOTAL}>
          <Text>{t('mobile.ticketsPicker.total')}</Text>
          <Text>{getFormattedMoney(buyerTotal)}</Text>
        </div>
      </div>
    </div>
  )
}
